import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api';

/**
 * TanStack Query setup — CLAUDE.md §4.7, §6.3. All server state goes through here. This is **not**
 * the browser cache: clearing that does not touch it, only a refetch or reload does.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /** The floor; each report overrides with its own source's sync cadence (§6.3). */
      staleTime: 5 * 60 * 1000,

      /** Dashboards get left open on a factory floor — refocusing should show current figures. */
      refetchOnWindowFocus: true,

      retry: (failureCount, error) => {
        // A 4xx will not become a 2xx by asking again; a 503 is worth one more attempt.
        if (error instanceof ApiError) {
          const { status } = error.problem;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 2;
      },
    },
  },
});
